import React from 'react';
import './VersionWarning.css';

interface VersionWarningProps {
  serverVersion: number;
  onRefresh: () => void;
  onDismiss: () => void;
}

const VersionWarning: React.FC<VersionWarningProps> = ({ serverVersion, onRefresh, onDismiss }) => {
  return (
    <div className="version-warning">
      <div className="version-warning-content">
        <div className="version-warning-icon">⚠️</div>
        <div className="version-warning-text">
          <div className="version-warning-title">На сервері є новіші дані</div>
          <div className="version-warning-description">
            Версія на сервері: {serverVersion}. Ваші локальні зміни можуть бути втрачені.
          </div>
        </div>
        <div className="version-warning-actions">
          <button className="version-warning-button refresh" onClick={onRefresh}>
            Оновити
          </button>
          <button className="version-warning-button dismiss" onClick={onDismiss}>
            Ігнорувати
          </button>
        </div>
      </div>
    </div>
  );
};

export default VersionWarning;

